<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <div
    class="flex flex-col space-y-4 items-stretch justify-start"
    [formGroup]="form"
  >
    <mat-form-field *ngIf="freeText">
      <mat-label>Description</mat-label>
      <input
        matInput
        formControlName="name"
        data-cy="free-text-description"
        required="true"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Unit Price</mat-label>
      <span matPrefix appAddCurrencyPrefix></span>
      <input
        matInput
        formControlName="price"
        data-cy="unit-price"
        required="true"
      />
      <mat-error *ngIf="form.controls['price'].hasError('required')"
        >Price is required</mat-error
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label>Quantity</mat-label>
      <input
        matInput
        formControlName="quantity"
        required="true"
        data-cy="quantity"
      />
      <mat-error *ngIf="form.controls['quantity'].hasError('required')"
        >Quantity is required</mat-error
      >
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-button
    (click)="save()"
    color="primary"
    [disabled]="form.invalid"
    data-cy="save-button"
  >
    Save
  </button>
</mat-dialog-actions>
